/**
 * Created by AlexanderC on 5/22/15.
 *
 * Bootstrap file loaded by npm as main
 */

'use strict';

var _DI = require('./DI');

module.exports = _DI.DI;


//////////////////
// WEBPACK FOOTER
// ../~/deep-di/lib.compiled/bootstrap.js
// module id = 379
// module chunks = 0